/**
 * jobcrawls concrete AuthAdapter. `canReview` wraps the existing backoffice
 * email allowlist and additionally honors a `translation_reviewer` role if the
 * session carries one (forward-compatible with a scoped role — see TEC-465 P4).
 *
 * This is the single gate for both the backoffice catalogue and the live
 * in-place overlay.
 */

import { isAuthorizedForBackofficeEmail } from '../../utils/auth/is-authorized-for-backoffice-email';
import type { AuthAdapter, ReviewUser } from '../core/adapters';

export const TRANSLATION_REVIEWER_ROLE = 'translation_reviewer';

export const backofficeAuthAdapter: AuthAdapter = {
  canReview(user: ReviewUser | null | undefined): boolean {
    if (!user) return false;
    if (user.roles?.includes(TRANSLATION_REVIEWER_ROLE)) return true;
    return isAuthorizedForBackofficeEmail(user.email);
  },
};

/** Convenience for server routes that only have an email at hand. */
export function canReviewEmail(email: string | null | undefined): boolean {
  return isAuthorizedForBackofficeEmail(email);
}
